/**
 * Host adapter for Microsoft PowerPoint
 *
 * Extracts text content from PowerPoint slides for AI analysis.
 */
export class PowerPointAdapter {
    hostType = 'powerpoint';
    async getDocumentContext() {
        return new Promise((resolve, reject) => {
            PowerPoint.run(async (context) => {
                try {
                    const presentation = context.presentation;
                    const slides = presentation.slides;
                    slides.load('items');
                    await context.sync();
                    const textParts = [];
                    for (let slideIndex = 0; slideIndex < slides.items.length; slideIndex++) {
                        const slide = slides.items[slideIndex];
                        const shapes = slide.shapes;
                        shapes.load('items');
                        await context.sync();
                        const slideTexts = [];
                        for (const shape of shapes.items) {
                            try {
                                const textFrame = shape.textFrame;
                                textFrame.load('hasText,textRange');
                                await context.sync();
                                if (textFrame.hasText) {
                                    const textRange = textFrame.textRange;
                                    textRange.load('text');
                                    await context.sync();
                                    const text = textRange.text?.trim();
                                    if (text) {
                                        slideTexts.push(text);
                                    }
                                }
                            }
                            catch {
                                // Shape doesn't support text frames (e.g. images, charts) — skip it
                            }
                        }
                        if (slideTexts.length > 0) {
                            textParts.push(`--- Slide ${slideIndex + 1} ---\n${slideTexts.join('\n')}`);
                        }
                    }
                    const content = textParts.length > 0
                        ? textParts.join('\n\n')
                        : 'No text content found in presentation';
                    resolve({
                        content,
                        metadata: {
                            source: 'powerpoint-presentation',
                            slideCount: String(slides.items.length),
                        },
                    });
                }
                catch (error) {
                    console.error('[PowerPointAdapter] Error extracting content:', error);
                    reject(error);
                }
            }).catch(reject);
        });
    }
    getDeploymentType() {
        return 'AddinPowerPoint';
    }
}
